/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_New_SelectedInputs */

const cs_chat_new_selected = /** @type {(inputs: Chat_New_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vybráno: ${i?.count}`)
};

const en_chat_new_selected = /** @type {(inputs: Chat_New_SelectedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Chat_New_SelectedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_new_selected = /** @type {((inputs: Chat_New_SelectedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_New_SelectedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_new_selected(inputs)
	return cs_chat_new_selected(inputs)
});